import { render, staticRenderFns } from "./StandardMenu.vue?vue&type=template&id=350f2c47"
import script from "./StandardMenu.vue?vue&type=script&lang=js"
export * from "./StandardMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports